import { useCallback, useEffect } from 'react';
import { useAppSelector } from 'app/store';
import { getPlayerMode } from 'app/store/AudioPlayer/selectors';
import { WaveSurferInstance } from './useWaveSurferPlayer';

interface UseFinishEventProps {
  player?: WaveSurferInstance | null;
  loop: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
  skip: () => void;
}

export const useFinishEvent = ({
  skip,
  loop,
  setIsPlaying,
  player,
}: UseFinishEventProps) => {
  const playMode = useAppSelector(getPlayerMode);

  const onFinishHandler = useCallback(() => {
    if (!loop && playMode === 'playlist') {
      skip();
      return;
    }

    player?.seekTo(0);
    if (loop) {
      player?.play();
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  }, [setIsPlaying, player, loop, playMode, skip]);

  useEffect(() => {
    player?.on('finish', onFinishHandler);
    return () => {
      player?.un('finish', onFinishHandler);
    };
  }, [player, onFinishHandler]);
};
